<template>
  <div class="terms-reminders-filters card border-0 shadow-sm mb-4">
    <div class="card-body">
      <form
        class="filter-row"
        @submit.prevent="$emit('search')"
      >
        <div class="count-block">
          <span class="count-num">{{ resultCount }}</span>
          <span class="count-lbl">results</span>
        </div>

        <div class="filter-search">
          <label
            class="form-label text-uppercase small text-muted fw-semibold"
            for="terms-reminder-search"
          >Search experts</label>
          <div class="input-group">
            <span class="input-group-text bg-white border-end-0">
              <i class="si si-magnifier text-muted" />
            </span>
            <input
              id="terms-reminder-search"
              v-model="expertName"
              type="search"
              class="form-control border-start-0"
              :class="{ 'border-active': expertName !== '' }"
              placeholder="Expert name"
              autocomplete="off"
            >
          </div>
        </div>

        <div class="filter-actions">
          <button
            type="submit"
            class="btn btn-primary"
          >
            <i class="si si-magnifier me-1" /> Search
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary"
            :class="{ 'btn-clear-active': expertName !== '' }"
            @click="clear"
          >
            <i class="si si-close me-1" /> Clear
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
    name: "ExpertTermsRemindersFilter",
    props: {
        value: {
            type: String,
            default: "",
        },
        resultCount: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        expertName: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        clear() {
            this.$emit("input", "");
            this.$emit("clear");
        },
    },
};
</script>

<style scoped>
.terms-reminders-filters {
    border-radius: 12px;
}

.filter-row {
    align-items: flex-end;
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
}

.count-block {
    align-self: center;
    border-right: 3px solid #153c4a;
    flex-shrink: 0;
    padding-right: 18px;
}

.count-num {
    color: #153c4a;
    display: block;
    font-size: 1.875rem;
    font-weight: 700;
    line-height: 1;
}

.count-lbl {
    color: #6c757d;
    display: block;
    font-size: 0.625rem;
    letter-spacing: 0.05em;
    margin-top: 2px;
    text-transform: uppercase;
}

.filter-search {
    flex: 1;
    min-width: 180px;
}

.filter-actions {
    display: flex;
    flex-shrink: 0;
    gap: 8px;
}

.border-active {
    border-color: #153c4a !important;
}

.btn-clear-active {
    border-color: #dc3545 !important;
    color: #dc3545 !important;
}
</style>
